export default __webpack_public_path__ + "static/media/team4.a35f13c4.png";